import { useEffect, useRef } from "react";

const ACTIVITY_EVENTS = ["pointerdown", "keydown", "touchstart", "input", "scroll"];

/**
 * Kiosk mode (pivony-api survey_kiosk): start over for the next person.
 *
 * - ``submitted``: after ``resetSeconds`` on the thank-you screen.
 * - ``inProgress`` (someone answered and walked away): after ``idleSeconds`` without a touch,
 *   key press or scroll, so the next person never sees their answers.
 *
 * Does nothing without ``kiosk``. ``onReset`` clears the page's state.
 */
export function useKioskReset({ kiosk, submitted, inProgress, onReset }) {
  const onResetRef = useRef(onReset);
  onResetRef.current = onReset;
  const resetSeconds = kiosk?.reset_seconds;
  const idleSeconds = kiosk?.idle_seconds;

  useEffect(() => {
    if (!kiosk || !submitted) return undefined;
    const timer = setTimeout(() => onResetRef.current(), (resetSeconds || 5) * 1000);
    return () => clearTimeout(timer);
  }, [kiosk, submitted, resetSeconds]);

  useEffect(() => {
    if (!kiosk || submitted || !inProgress) return undefined;
    let timer;
    const arm = () => {
      clearTimeout(timer);
      timer = setTimeout(() => onResetRef.current(), (idleSeconds || 60) * 1000);
    };
    arm();
    ACTIVITY_EVENTS.forEach((name) => window.addEventListener(name, arm, { passive: true }));
    return () => {
      clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((name) => window.removeEventListener(name, arm));
    };
  }, [kiosk, submitted, inProgress, idleSeconds]);
}
